import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, role, permission }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Allow array of roles for shared pages (e.g. admin viewing agent quote PDF)
  if (Array.isArray(role)) {
    if (!role.includes(user?.role)) {
      return <Navigate to={user?.role === "admin" || user?.role === "employee" ? "/admin" : "/agent"} replace />;
    }
    if (permission && user?.role === "employee") {
      if (!user.permissions?.includes(permission)) {
        return <Navigate to="/admin" replace />;
      }
    }
    return children;
  }

  // Handle Admin/Employee Roles
  if (role === "admin") {
    if (user?.role !== "admin" && user?.role !== "employee") {
      return <Navigate to="/agent" replace />;
    }
    
    // Check specific permission if required
    if (permission && user?.role === "employee") {
      if (!user.permissions?.includes(permission)) {
        return <Navigate to="/admin" replace />;
      }
    }
  }

  // Handle Agent Role
  if (role === "agent") {
    if (user?.role === "admin" || user?.role === "employee") {
      return <Navigate to="/admin" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
